export default "__VITE_ASSET__D$E3HkFQ__"